import React, { Component } from "react";
import { MetaTags } from "react-meta-tags";
import Topnav from "../common/Topnav";
import Menubar from "../common/Menubar";
import Sec1 from "../placement/Sec1";
import Sec2 from "../placement/Sec2";
import Sec3 from "../placement/Sec3";

class Placements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
        };
    }

    openModal = () => {
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    render() {
        return (
            <>
                <MetaTags>{/* Meta tags content */}</MetaTags>
                <Topnav />
                <Menubar />
                <Sec1 />
                <Sec2 />
                <Sec3 />
            </>
        );
    }
}

export default Placements;
